// extracted by mini-css-extract-plugin
module.exports = {"Container":"BackgroundVideo_Container__210jC","Video":"BackgroundVideo_Video__2FB9j","Content":"BackgroundVideo_Content__1MufR","SubContent":"BackgroundVideo_SubContent__3a1OB"};